import { useEffect, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

import { usePLPFacetsContext } from '../facets-context/facets-context'

interface Params {
    isBasicMetasLoading: boolean
}

export default function usePLPInitialLoading({ isBasicMetasLoading }: Params) {
    const { searchParams } = usePLPFacetsContext()
    const [isLoading, setIsLoading] = useState(true)

    const queryClient = useQueryClient()

    const enabled = !isBasicMetasLoading && !!searchParams

    useEffect(() => {
        if (!enabled) return

        const init = async () => {
            await queryClient.refetchQueries({ queryKey: QueryKeys.PLP.PagesData(searchParams), exact: true })

            setIsLoading(false)
        }

        init()
    }, [queryClient, enabled, searchParams])

    return isLoading
}
